import React from "react";
import { HelpCenterCtaV3 as HelpCenterCTA } from "./HelpCenterCTA";
import { ChatCtaV3 as ChatCTA } from "./ChatCTA";
import { PhoneCTA } from "./PhoneCTA";

export interface NavBarHelpCTAsProps {
    helpCenterContext: {
        visible: boolean | null;
        helpCenterSidePanelVisible: boolean | null;
    };
    isChatEnabled: boolean | null;
    providerPhoneNumber: string;
}

export const NavBarHelpCTAs = ({
    helpCenterContext,
    isChatEnabled,
    providerPhoneNumber,
}: NavBarHelpCTAsProps) => {
    const { visible: isHelpCenterEnabled } = helpCenterContext;
    if (isHelpCenterEnabled) {
        return <HelpCenterCTA />;
    }
    if (isChatEnabled) {
        return <ChatCTA />;
    }
    if (providerPhoneNumber) {
        return <PhoneCTA providerPhoneNumber={providerPhoneNumber} />;
    }
    return null;
};
